<template>
  <th
    :class="classList"
    :tabindex="header.sortBy ? '0' : '-1'"
    @click="header.sortBy ? sort(header.sortBy) : () => {}"
    @keydown.enter="header.sortBy ? sort(header.sortBy) : () => {}"
  >
    <div class="st-table-header__container">
      <span class="st-table-header__container__span">
        {{ header.name }}
      </span>
      <div v-if="header.sortBy" :class="sortedClassList">
        <span aria-hidden="true">
          <component
            :is="icon"
            :size="'xs'"
            name="arrow-down"
            :alt="header.name"
            useSvg
            inline
          />
        </span>
        <span aria-hidden="true">
          <component
            :is="icon"
            :size="'xs'"
            name="arrow-down"
            :alt="header.name"
            useSvg
            inline
          />
        </span>
      </div>
    </div>
  </th>
</template>

<script>
import StIcon from "../icon/Icon.vue";
import StIconLegacy from "../icon/IconLegacy.vue";
import { version } from "vue";
export default {
  components: {
    StIcon,
    StIconLegacy,
  },
  props: {
    header: Object,
    isSorted: Boolean,
  },
  data() {
    return {
      sortOrder: "",
    };
  },
  computed: {
    classList: function () {
      return [
        "st-table-header",
        this.header.sortBy && "st-table-header--is-sortable",
      ];
    },
    sortedClassList() {
      const header = "st-table-header__container__sort";
      return [
        header,
        this.isSorted && this.sortOrder === "asc" && `${header}--asc`,
        this.isSorted && this.sortOrder === "desc" && `${header}--desc`,
      ];
    },
    icon() {
      return version && parseInt(version) === 3 ? "StIcon" : "StIconLegacy";
    },
  },
  methods: {
    sort(sortBy) {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      this.$emit("sort", sortBy, this.sortOrder);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-table-header {
  user-select: none;
  @include large {
    padding: rem-calc(22);
  }
  &--is-sortable {
    cursor: pointer;
    &:focus {
      outline: rem-calc(2) solid $dark-grey;
    }
  }
  &__container {
    display: flex;
    align-items: center;

    &__span {
      color: $dark-grey;
      font-weight: $semi-bold;
      word-break: break-all;
      font-size: rem-calc(16);
    }

    & > :not(:last-child) {
      margin-right: rem-calc(6);
    }

    &__sort {
      display: flex;
      flex-direction: column;

      & > :first-child {
        display: flex;
        transform: rotate(180deg);
        margin-bottom: rem-calc(1);
        padding-bottom: rem-calc(5);
        opacity: 0.5;

        & > :first-child {
          height: auto;
        }
      }

      & > :last-child {
        display: flex;
        margin-top: rem-calc(1);
        padding-bottom: rem-calc(5);
        opacity: 0.5;

        & > :first-child {
          height: auto;
        }
      }

      &--asc {
        & > :first-child {
          opacity: 1;
        }
      }

      &--desc {
        & > :last-child {
          opacity: 1;
        }
      }
    }
  }
}
</style>
